/**
 * @generated SignedSource<<71c6c67a9ce7cb458b3e46d84e751c41>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useEditorContentModeValue_content$data = {
  readonly contentProperties: {
    readonly draft: {
      readonly contentMode: string | null;
    } | null;
    readonly latest: {
      readonly contentMode: string | null;
    } | null;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "useEditorContentModeValue_content";
};
export type useEditorContentModeValue_content$key = {
  readonly " $data"?: useEditorContentModeValue_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEditorContentModeValue_content">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "contentMode"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useEditorContentModeValue_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "ContentProperties",
      "kind": "LinkedField",
      "name": "contentProperties",
      "plural": false,
      "selections": [
        {
          "concreteType": "PublishedContentProperties",
          "kind": "LinkedField",
          "name": "latest",
          "plural": false,
          "selections": (v0/*: any*/)
        },
        {
          "concreteType": "DraftContentProperties",
          "kind": "LinkedField",
          "name": "draft",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "9ebadf8a582f1b80901c057e51756064";

export default node;
